export interface FilterItem {
    id?: number;
    field: string;
    label: string;
    value: object | string | number | boolean | null;
}
